package de.emgress.baskets.modules.schedule

import androidx.compose.runtime.Composable
import de.emgress.baskets.core.styles.Styles
import dtos.sponsor.SponsorDTOOut
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img

@Composable
fun ScheduleSponsor(
    mSponsor: SponsorDTOOut?
) {
    mSponsor?.let { sponsor ->
        Div({
            classes(Styles.cssClasses.rowCentered, Styles.cssClasses.marginMedium)
        }) {
            Img(
                src = sponsor.mImageUrl1.orEmpty()
            ) {
                classes(Styles.cssClasses.scheduleSponsorImage)
            }
        }
    }
}